export enum ESpecStatus {
  NotActive = 'not_active',
  Blocked = 'blocked',
  Active = 'active',
}
